import { create, tsx } from '@dojo/framework/core/vdom';
import { LinkButton } from './LinkButton';
import { Text } from './Text';

import * as css from './CareerPosition.m.css';

export interface CareerPositionProperties {
	title: string;
	route: string;
}

const factory = create().properties<CareerPositionProperties>();

export const CareerPosition = factory(function CareerPosition({ children, properties }) {
	const { title, route } = properties();

	return (
		<div classes={css.info}>
			<Text type="subhead">{title}</Text>
			<div classes={[css.blurb]}>
				<Text type="body">{children()}</Text>
			</div>
			<LinkButton to="careerPage" params={{ jobId: route }}>
				Learn more
			</LinkButton>
		</div>
	);
});

export default CareerPosition;
